import Link from "next/link";
import { FormattedMessage, useIntl } from "react-intl";
// Import Images
import CorrectIcon from "@/assets/svgs/correct.svg";

const ContentComponent = ({ data, hrefBtn }) => {
  const { locale } = useIntl();
  return (
    <div className="content">
      <h2 className="title">{data?.title?.[locale]}</h2>
      <p>{data?.subTitle?.[locale]}</p>
      <ul>
        {data?.content?.items?.map((item, index) => (
          <li key={index}>
            <div className="list-item">
              <CorrectIcon />
              <h3 className="text">{item?.title?.[locale]}</h3>
            </div>
          </li>
        ))}
      </ul>
      {hrefBtn?.link?.length > 0 && (
        <Link href={hrefBtn?.link || "/"}>
          <a className="btn-md">
            <FormattedMessage id="readMore" />
          </a>
        </Link>
      )}
    </div>
  );
};

export default ContentComponent;
